(function () {
  if (window.__ctrSimpleBuyButtonInit) return;
  window.__ctrSimpleBuyButtonInit = true;

  function initSimpleCtrBuyButtons(scope) {
    var root = scope || document;
    var buttons = root.querySelectorAll('[data-ctr-button-mode="simple"][data-ctr-subscribe-btn]');
    if (!buttons.length) return;

    function formatUsdFromCents(cents) {
      var value = Number(cents) || 0;
      var amount = value / 100;
      var formatted = amount % 1 === 0 ? String(amount) : amount.toFixed(2).replace(/\.?0+$/, '');
      return '$' + formatted;
    }

    function formatShopMoneyFromCents(cents) {
      var moneyFormat =
        (window.FoxTheme && window.FoxTheme.settings && window.FoxTheme.settings.moneyFormat) ||
        '${{amount}}';
      var value = Number(cents) || 0;

      function stripTrailingZeros(amountText) {
        if (!amountText) return amountText;
        return amountText
          .replace(/([.,]\d*?[1-9])0+(?=[^\d]|$)/, '$1')
          .replace(/[.,]0+(?=[^\d]|$)/, '');
      }

      if (window.FoxTheme && window.FoxTheme.Currency && typeof window.FoxTheme.Currency.formatMoney === 'function') {
        return stripTrailingZeros(window.FoxTheme.Currency.formatMoney(value, moneyFormat));
      }

      return formatUsdFromCents(value);
    }

    function formatMoneyFromCents(cents, useUsdOverride) {
      return useUsdOverride ? formatUsdFromCents(cents) : formatShopMoneyFromCents(cents);
    }

    function handleAfterAdd(triggerButton) {
      var afterAddAction = triggerButton && triggerButton.getAttribute('data-after-add-action');
      if (afterAddAction === 'checkout') {
        // Skip-cart path: write the recurring-total attribute before navigating.
        (window.RecurringBridge ? window.RecurringBridge.flush() : Promise.resolve())
          .then(function () { window.location.href = '/checkout'; });
        return;
      }

      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.show(triggerButton);
      } else {
        window.location.href = '/cart';
      }
    }

    async function addSimpleItem(variantId, sellingPlanId, triggerButton, withSellingPlan) {
      if (!variantId) return;

      var item = {
        id: Number(variantId),
        quantity: 1
      };

      if (withSellingPlan && sellingPlanId) item.selling_plan = Number(sellingPlanId);

      try {
        triggerButton.setAttribute('aria-disabled', 'true');
        triggerButton.classList.add('is-loading');

        var sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );

        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [item],
            sections: sectionsToBundle,
            sections_url: window.location.pathname
          })
        });

        if (!response.ok) {
          var error = await response.json();
          alert(error.description || 'Error adding to cart.');
          return;
        }

        var parsedState = await response.json();
        var cartResponse = await fetch('/cart.js', FoxTheme.utils.fetchConfig());
        var cartJson = await cartResponse.json();
        cartJson.sections = parsedState.sections;
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });

        handleAfterAdd(triggerButton);
      } catch (error) {
        console.error('Simple CTR buy button error:', error);
        alert('Something went wrong. Please try again.');
      } finally {
        triggerButton.removeAttribute('aria-disabled');
        triggerButton.classList.remove('is-loading');
      }
    }

    buttons.forEach(function (button) {
      var container = button.parentElement || root;
      var purchaseOptions = container.querySelectorAll('[data-ctr-purchase-option]');
      var oneTimePriceEl = container.querySelector('[data-ctr-purchase-price="one_time"]');
      var subscribePriceEl = container.querySelector('[data-ctr-purchase-price="subscribe"]');
      var purchaseBadgeEl = container.querySelector('[data-ctr-purchase-badge]');
      var subscribeCompareEl = container.querySelector('[data-ctr-purchase-compare]');
      var oneTimeLinkWrap = container.querySelector('[data-ctr-one-time-link-wrap]');
      var oneTimeLink = container.querySelector('[data-ctr-one-time-link]');
      var oneTimeLinkPriceEl = container.querySelector('[data-ctr-one-time-link-price]');
      var optionPriceSuffix = button.hasAttribute('data-option-price-suffix')
        ? button.getAttribute('data-option-price-suffix')
        : '/ea';

      function getPrices() {
        return {
          oneTimeCents: Number(button.getAttribute('data-onetime-price-cents')) || 0,
          subscribeCents: Number(button.getAttribute('data-subscribe-price-cents')) || 0,
          oneTimeUsd: button.getAttribute('data-onetime-usd-override') === 'true',
          subscribeUsd: button.getAttribute('data-subscribe-usd-override') === 'true'
        };
      }

      function canCompareSavings(prices) {
        return prices.oneTimeUsd === prices.subscribeUsd;
      }

      function getSavingsPercent(prices) {
        if (!canCompareSavings(prices)) return 0;
        if (!(prices.oneTimeCents > prices.subscribeCents && prices.oneTimeCents > 0)) return 0;
        return Math.round(((prices.oneTimeCents - prices.subscribeCents) / prices.oneTimeCents) * 100);
      }

      function formatBadgeText(template, savingsPercent) {
        if (!template) return '';
        if (!/\[saving\]/i.test(template)) return template;
        if (!(savingsPercent > 0)) return '';
        return template.replace(/\[saving\]/gi, savingsPercent + '%');
      }

      function formatButtonText(template, priceText) {
        if (!template) return '';
        if (!/\[price\]/i.test(template)) return template;
        return template.replace(/\[price\]/gi, priceText || '');
      }

      function isSubscribeSelected() {
        if (!purchaseOptions.length) return true;
        var selected = container.querySelector('[data-ctr-purchase-option]:checked');
        return selected && selected.value === 'subscribe';
      }

      function isSoldOut() {
        return button.getAttribute('data-available') === 'false' || button.disabled;
      }

      function syncSoldOutState() {
        var soldOut = isSoldOut();
        if (oneTimeLinkWrap) oneTimeLinkWrap.hidden = soldOut;
        button.classList.toggle('is-active', !soldOut);
        button.disabled = soldOut;
        if (soldOut) {
          button.setAttribute('aria-disabled', 'true');
          button.setAttribute('data-available', 'false');
          var soldOutText = button.getAttribute('data-sold-out-text') || 'Sold out';
          var disEl = button.querySelector('.ctr-buy-button__subscribe-dis');
          if (disEl) disEl.textContent = soldOutText;
        } else {
          button.removeAttribute('aria-disabled');
          button.setAttribute('data-available', 'true');
        }
      }

      function syncButtonText() {
        if (isSoldOut()) return;

        var buttonTextEls = button.querySelectorAll('[data-ctr-button-text]');
        if (!buttonTextEls.length) return;

        var template = button.getAttribute('data-button-text-template') || '';
        if (!/\[price\]/i.test(template)) return;

        var prices = getPrices();
        var isSubscribe = isSubscribeSelected();
        var selectedCents = isSubscribe ? prices.subscribeCents || prices.oneTimeCents : prices.oneTimeCents;
        var selectedUsd = isSubscribe ? prices.subscribeUsd : prices.oneTimeUsd;
        var priceText = formatMoneyFromCents(selectedCents, selectedUsd);
        var buttonText = formatButtonText(template, priceText);

        buttonTextEls.forEach(function (el) {
          el.textContent = buttonText;
        });
      }

      function syncPurchasePrices() {
        var prices = getPrices();
        if (oneTimePriceEl) {
          oneTimePriceEl.textContent = formatMoneyFromCents(prices.oneTimeCents, prices.oneTimeUsd) + optionPriceSuffix;
        }
        if (subscribePriceEl) {
          subscribePriceEl.textContent = formatMoneyFromCents(prices.subscribeCents, prices.subscribeUsd) + optionPriceSuffix;
        }
        if (subscribeCompareEl) {
          var showCompare = canCompareSavings(prices) && prices.oneTimeCents > prices.subscribeCents;
          subscribeCompareEl.textContent = showCompare
            ? formatMoneyFromCents(prices.oneTimeCents, prices.oneTimeUsd) + optionPriceSuffix
            : '';
          subscribeCompareEl.hidden = !showCompare;
        }
        if (oneTimeLinkPriceEl) {
          oneTimeLinkPriceEl.textContent = formatMoneyFromCents(prices.oneTimeCents, prices.oneTimeUsd);
        }
      }

      function syncSavingsBadge() {
        if (!purchaseBadgeEl) return;

        var prices = getPrices();
        var template = button.getAttribute('data-badge-template') || '';
        var savingsPercent = getSavingsPercent(prices);
        var badgeText = formatBadgeText(template, savingsPercent);

        if (badgeText) {
          purchaseBadgeEl.textContent = badgeText;
          purchaseBadgeEl.hidden = false;
        } else if (/\[saving\]/i.test(template)) {
          purchaseBadgeEl.hidden = true;
        } else if (template) {
          purchaseBadgeEl.textContent = template;
          purchaseBadgeEl.hidden = false;
        } else {
          purchaseBadgeEl.hidden = true;
        }
      }

      function syncMainPriceRow() {
        var sectionRoot = button.closest('.shopify-section') || document;
        var priceRoot = sectionRoot.querySelector('[data-ctr-price]');
        if (!priceRoot) return;

        var currentEl = priceRoot.querySelector('.ctr-price__current');
        var compareEl = priceRoot.querySelector('.ctr-price__compare');
        var badgeEl = priceRoot.querySelector('.ctr-price__badge');
        var badgeTextEl = priceRoot.querySelector('.ctr-price__badge-text');
        var isSubscribe = isSubscribeSelected();
        var prices = getPrices();
        var oneTimeCents = prices.oneTimeCents;
        var subscribeCents = prices.subscribeCents || oneTimeCents;
        var selectedCents = isSubscribe ? subscribeCents : oneTimeCents;
        var selectedUsd = isSubscribe ? prices.subscribeUsd : prices.oneTimeUsd;
        var savingsPercent = getSavingsPercent(prices);
        var badgeTemplate = button.getAttribute('data-badge-template') || '[saving] OFF TODAY';
        var hasSubscribeSavings = isSubscribe && canCompareSavings(prices) && oneTimeCents > subscribeCents;

        // Keep Liquid-rendered product compare/badge so we can restore when
        // OTP→subscribe savings aren't being shown.
        if (!priceRoot.dataset.ctrPriceFallbackCached) {
          priceRoot.dataset.ctrPriceFallbackCached = 'true';
          priceRoot.dataset.ctrPriceCompareText = compareEl ? (compareEl.textContent || '').trim() : '';
          priceRoot.dataset.ctrPriceBadgeText = badgeTextEl ? (badgeTextEl.textContent || '').trim() : '';
        }

        if (currentEl) {
          currentEl.textContent = formatMoneyFromCents(selectedCents, selectedUsd);
        }

        if (!compareEl) return;

        if (hasSubscribeSavings) {
          compareEl.textContent = formatMoneyFromCents(oneTimeCents, prices.oneTimeUsd);
          compareEl.style.display = '';
          if (badgeEl) {
            badgeEl.style.display = '';
            if (badgeTextEl) {
              badgeTextEl.textContent = formatBadgeText(badgeTemplate, savingsPercent) || savingsPercent + '% OFF TODAY';
            }
          }
        } else if (priceRoot.dataset.ctrPriceCompareText) {
          compareEl.textContent = priceRoot.dataset.ctrPriceCompareText;
          compareEl.style.display = '';
          if (badgeEl) {
            if (priceRoot.dataset.ctrPriceBadgeText) {
              badgeEl.style.display = '';
              if (badgeTextEl) badgeTextEl.textContent = priceRoot.dataset.ctrPriceBadgeText;
            } else {
              badgeEl.style.display = 'none';
            }
          }
        } else {
          compareEl.style.display = 'none';
          if (badgeEl) badgeEl.style.display = 'none';
        }
      }

      function updatePriceFallbackFromVariant(priceCents, compareCents) {
        var sectionRoot = button.closest('.shopify-section') || document;
        var priceRoot = sectionRoot.querySelector('[data-ctr-price]');
        if (!priceRoot) return;

        var row = priceRoot.querySelector('.ctr-price__row');
        var compareEl = priceRoot.querySelector('.ctr-price__compare');
        var badgeEl = priceRoot.querySelector('.ctr-price__badge');
        var badgeTextEl = priceRoot.querySelector('.ctr-price__badge-text');

        if (compareCents > priceCents && priceCents > 0) {
          var pct = Math.round(((compareCents - priceCents) / compareCents) * 100);
          var compareText = formatMoneyFromCents(compareCents, false);
          var existingBadge = priceRoot.dataset.ctrPriceBadgeText || (badgeTextEl && badgeTextEl.textContent) || '';
          var label = (existingBadge.replace(/^\d+%\s*/, '').trim()) || 'OFF TODAY';

          priceRoot.dataset.ctrPriceCompareText = compareText;
          priceRoot.dataset.ctrPriceBadgeText = pct + '% ' + label;

          if (!compareEl && row) {
            compareEl = document.createElement('span');
            compareEl.className = 'ctr-price__compare';
            row.appendChild(compareEl);
          }
          if (compareEl) compareEl.textContent = compareText;

          if (!badgeEl && row) {
            badgeEl = document.createElement('span');
            badgeEl.className = 'ctr-price__badge';
            badgeTextEl = document.createElement('span');
            badgeTextEl.className = 'ctr-price__badge-text';
            badgeEl.appendChild(badgeTextEl);
            row.appendChild(badgeEl);
          } else if (badgeEl && !badgeTextEl) {
            badgeTextEl = badgeEl.querySelector('.ctr-price__badge-text');
          }
          if (badgeTextEl) badgeTextEl.textContent = priceRoot.dataset.ctrPriceBadgeText;
        } else {
          priceRoot.dataset.ctrPriceCompareText = '';
          priceRoot.dataset.ctrPriceBadgeText = '';
          if (compareEl) compareEl.style.display = 'none';
          if (badgeEl) badgeEl.style.display = 'none';
        }

        priceRoot.dataset.ctrPriceFallbackCached = 'true';
      }

      function applyVariantFromCard(card) {
        if (!card) return;

        var variantId = card.getAttribute('data-variant-id');
        var available = card.getAttribute('data-variant-available') !== 'false';
        var priceCents = Number(card.getAttribute('data-price-cents')) || 0;
        var compareCents = Number(card.getAttribute('data-compare-at-cents')) || 0;
        var sellingPlanId = card.getAttribute('data-selling-plan-id') || '';
        var subscribeCents = Number(card.getAttribute('data-subscribe-price-cents')) || priceCents;

        if (variantId) button.setAttribute('data-variant-id', variantId);
        button.setAttribute('data-selling-plan-id', sellingPlanId);
        button.setAttribute('data-available', available ? 'true' : 'false');
        button.disabled = !available;

        if (button.getAttribute('data-onetime-usd-override') !== 'true' && priceCents > 0) {
          button.setAttribute('data-onetime-price-cents', String(priceCents));
        }
        if (button.getAttribute('data-subscribe-usd-override') !== 'true') {
          button.setAttribute('data-subscribe-price-cents', String(subscribeCents > 0 ? subscribeCents : priceCents));
        }

        updatePriceFallbackFromVariant(priceCents, compareCents);
        syncPurchaseUI();
      }

      // Size cards show the subscription price (one-time crossed out) while
      // Subscribe & save is selected. Only when the block asks for the
      // subscribe strikethrough, so other templates keep plain card prices.
      function syncVariantCardPrices() {
        if (button.getAttribute('data-subscribe-compare') !== 'true') return;
        var sectionRoot = button.closest('.shopify-section') || document;
        var showSubscribe = purchaseOptions.length > 0 && isSubscribeSelected();

        sectionRoot.querySelectorAll('[data-ctr-variant-card]').forEach(function (card) {
          var priceEl = card.querySelector('.ctr-variant-selector__price');
          if (!priceEl) return;
          if (priceEl.dataset.ctrOriginalPrice === undefined) {
            priceEl.dataset.ctrOriginalPrice = priceEl.textContent;
          }

          var oneTimeCents = Number(card.getAttribute('data-price-cents')) || 0;
          var subscribeCents = Number(card.getAttribute('data-subscribe-price-cents')) || 0;
          var hasPlan = !!card.getAttribute('data-selling-plan-id');

          if (showSubscribe && hasPlan && subscribeCents > 0 && subscribeCents < oneTimeCents) {
            priceEl.innerHTML =
              '<span class="ctr-variant-selector__price-compare">' +
              formatMoneyFromCents(oneTimeCents, false) +
              '</span> ' +
              formatMoneyFromCents(subscribeCents, false);
          } else {
            priceEl.textContent = priceEl.dataset.ctrOriginalPrice;
          }
        });
      }

      function syncPurchaseUI() {
        syncVariantCardPrices();
        syncSoldOutState();
        if (isSoldOut()) return;
        syncPurchasePrices();
        syncSavingsBadge();
        syncMainPriceRow();
        syncButtonText();
      }

      button._ctrApplyVariantCard = applyVariantFromCard;

      var sectionRoot = button.closest('.shopify-section') || document;
      var activeVariantCard = sectionRoot.querySelector('[data-ctr-variant-card].is-active');
      if (activeVariantCard) {
        applyVariantFromCard(activeVariantCard);
      } else {
        syncPurchaseUI();
      }

      if (button.dataset.ctrSimpleInit === 'true') return;
      button.dataset.ctrSimpleInit = 'true';

      purchaseOptions.forEach(function (input) {
        input.addEventListener('change', syncPurchaseUI);
      });

      button.addEventListener('click', async function (event) {
        event.preventDefault();
        if (isSoldOut()) return;
        var useSellingPlan = purchaseOptions.length ? isSubscribeSelected() : true;
        addSimpleItem(
          button.getAttribute('data-variant-id'),
          button.getAttribute('data-selling-plan-id'),
          button,
          useSellingPlan
        );
      });

      if (oneTimeLink) {
        oneTimeLink.addEventListener('click', function (event) {
          event.preventDefault();
          if (isSoldOut()) return;
          addSimpleItem(button.getAttribute('data-variant-id'), '', oneTimeLink, false);
        });
      }
    });

  }

  if (!window.__ctrSimpleBuyButtonVariantBound) {
    window.__ctrSimpleBuyButtonVariantBound = true;
    document.addEventListener('ctr:variant-selected', function (event) {
      var detail = event.detail || {};
      var card = detail.card;
      if (!card) return;

      var sectionRoot = card.closest('.shopify-section') || document;
      var button = sectionRoot.querySelector('[data-ctr-button-mode="simple"][data-ctr-subscribe-btn]');
      if (!button || typeof button._ctrApplyVariantCard !== 'function') return;
      button._ctrApplyVariantCard(card);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSimpleCtrBuyButtons(document);
  });

  window.addEventListener('pageshow', function () {
    initSimpleCtrBuyButtons(document);
  });

  window.initSimpleCtrBuyButtons = initSimpleCtrBuyButtons;

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initSimpleCtrBuyButtons(event.target);
    });
  }
})();
